import { createContext } from "react";
import { Me } from '../apollo/types/globalTypes';

interface UserContextInterface extends Me {}

export const UserContext = createContext({} as UserContextInterface);

